import { render, staticRenderFns } from "./reportSettings.vue?vue&type=template&id=0b7ea368"
import script from "./reportSettings.vue?vue&type=script&lang=js"
export * from "./reportSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports